import styled from 'styled-components';

export const IncRateProp = styled.div`
  background: #ffffff;
  border-radius: 1.2rem;
  margin: 1rem 0 2.8rem;
  position: relative;
`;

export const IncRatePropSlider = styled.div`
  box-sizing: border-box;
  padding: 2rem 0 2.3rem 2.4rem;
  overflow: hidden;
  position: relative;
  .incRateProp__slider--item {
    margin-right: 1.5rem;
    outline: 0;
    border: 0;
    p {
      font-weight: 600;
      font-size: 1.4rem;
      color: #141823;
    }
  }
  .incRateProp__slider--itemImg {
    height: 13rem;
    border-radius: 0.4rem;
    object-fit: cover;
    width: 100%;
    margin-bottom: 1.2rem;
  }

  /* Slider */
  .slick-slider {
    display: flex;
    position: relative;
  }
  .slick-initialized .slick-slide > div {
    flex: 1;
  }
  .slick-slide {
    margin-right: 1.5rem;
  }
  .slick-list {
    overflow: hidden;
  }
  .slick-arrow {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.25);
    background-color: #fff;
    color: transparent;
    position: absolute;
  }
  .slick-track {
    display: flex !important;
    flex-direction: 'row';
  }
  .slick-next:before,
  .slick-prev:before {
    opacity: 1;
  }
  .slick-next:before,
  .slick-prev:before {
    border: solid #008cff;
    border-width: 0 0.3rem 0.3rem 0;
    display: inline-block;
    padding: 0.6rem;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    position: absolute;
    right: 1.6rem;
    top: 1.3rem;
    content: '';
  }
  .slick-prev:before {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    position: absolute;
    right: 1.2rem;
    top: 1.3rem;
  }
  .slick-prev {
    z-index: 1;
    left: -1.8rem;
    top: 4rem;
  }
  .slick-next {
    z-index: 1;
    right: -1.8rem;
    top: 4rem;
  }
  .slick-arrow.slick-disabled {
    display: none !important;
  }
`;

export const IncRatePropHeader = styled.div`
  background-color: #eef4fd;
  padding: 1.2rem 2.4rem 1.4rem;
  display: flex;
  align-items: center;
  border-top-left-radius: 1.2rem;
  border-top-right-radius: 1.2rem;
  a {
    font-size: 1.4rem;
    color: #2276e3;
    margin-left: auto;
    display: flex;
    align-items: center;
    .learnMoreArrow {
      border: solid #2276e3;
      border-width: 0 0.2rem 0.2rem 0;
      display: inline-block;
      padding: 0.2rem;
      margin-left: 0.8rem;
      content: '';
      transform: rotate(-45deg);
    }
  }
`;

export const IncRatePropHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  .incRateProp__heading {
    font-size: 1.6rem;
    font-weight: 900;
    color: #141823;
  }
  .incRateProp__subHeading {
    font-size: 1.4rem;
    color: #18a160;
  }
`;

export const SliderArrowLeft = styled.button(
  props => `
      z-index: ${props.theme.misc.zIndex.small};
      position: absolute;
      left: 0;
      width: 4rem;
      height: 4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: ${props.theme.misc.borderRadius.round};
      background-color: ${props.theme.colors.goWhite.base};
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: -1rem;
      transform: translateY(-50%);
      box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
      border:none;
      &:focus{
        outline: none;
      }
    `,
);

export const SliderArrowRight = styled.button(
  props => `
      z-index: ${props.theme.misc.zIndex.small};
      position: absolute;
      right: 0;
      width: 4rem;
      height: 4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: ${props.theme.misc.borderRadius.round};
      background-color: ${props.theme.colors.goWhite.base};
      cursor: pointer;
      position: absolute;
      top: 50%;
      right: -1rem;
      transform: translateY(-50%);
      box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
      border:none;
      &:focus{
        outline: none;
      }
    `,
);

export const HomeCaroSliderInnerWrap = styled.ul(
  props => `
      display: flex;
      justify-content:space-between;
      position: relative;
      margin-left: ${props.snapLeftMargin ? '-2.4rem' : 'auto'};
      li {
        position: relative;
        min-width: 100%;
        background: transparent;
        padding-left: 2.4rem;
        position: relative;
        min-width: ${props.listItemWidth || '50%'};
        display: flex;
        flex-direction: column;
        border-radius: ${props.theme.misc.borderRadius.xxxlarge};
        margin-bottom: ${props.marginBottom || 0};
        cursor: pointer;
      }
    `,
);
